module.exports = __webpack_public_path__ + "static/media/heifer.90053836.svg";